"use client";

import { useEffect, useRef } from "react";

interface HardRedirectClientProps {
  href: string;
}

/** Performs the immediate browser navigation after the server fallback is available. */
export default function HardRedirectClient({ href }: HardRedirectClientProps) {
  const hasNavigated = useRef(false);

  useEffect(() => {
    if (hasNavigated.current) return;

    hasNavigated.current = true;
    globalThis.location.assign(href);
  }, [href]);

  return null;
}
